var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.productHasMedia && !_vm.onPlp
    ? _c(
        "a",
        {
          class: _vm.imageWrapperClasses,
          attrs: {
            href: _vm.product.context_url,
            "aria-label": _vm.product.title
          }
        },
        [
          _vm.productHasMultipleMedia
            ? _c(
                "div",
                { staticClass: "product-item__images", style: _vm.getHeight },
                [
                  _c(
                    "div",
                    { staticClass: "product-item__sizer" },
                    [
                      _c("VImage", {
                        attrs: {
                          "alt-text": _vm.product.featured_image.alt,
                          "aspect-ratio":
                            _vm.product.featured_image.aspect_ratio,
                          "disable-aspect-ratio": _vm.includesAspectRatio,
                          height: _vm.product.featured_image.height,
                          "placeholder-src":
                            _vm.product.featured_image.placeholder_src,
                          src: _vm.product.featured_image.src,
                          width: _vm.product.featured_image.width
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "product-item__image first" },
                    [
                      _c("VImage", {
                        attrs: {
                          "alt-text": _vm.product.featured_image.alt,
                          "aspect-ratio":
                            _vm.product.featured_image.aspect_ratio,
                          "disable-aspect-ratio": _vm.includesAspectRatio,
                          height: _vm.product.featured_image.height,
                          "placeholder-src":
                            _vm.product.featured_image.placeholder_src,
                          src: _vm.product.featured_image.src,
                          width: _vm.product.featured_image.width
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "product-item__image not-first" },
                    [
                      _c("VImage", {
                        attrs: {
                          "alt-text": _vm.product.media[1].alt,
                          "aspect-ratio": _vm.product.media[1].aspect_ratio,
                          "disable-aspect-ratio": "",
                          height: _vm.product.media[1].height,
                          "placeholder-src":
                            _vm.product.media[1].placeholder_src,
                          src: _vm.product.media[1].src,
                          width: _vm.product.media[1].width
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _c(
                "div",
                { staticClass: "product-item__image" },
                [
                  _c("VImage", {
                    attrs: {
                      "alt-text": _vm.featuredImage.alt,
                      "aspect-ratio": _vm.featuredImage.aspect_ratio,
                      "disable-aspect-ratio": _vm.includesAspectRatio,
                      height: _vm.featuredImage.height,
                      "placeholder-src": _vm.featuredImage.placeholder_src,
                      src: _vm.featuredImage.src,
                      width: _vm.featuredImage.width
                    }
                  })
                ],
                1
              )
        ]
      )
    : _vm.productHasMedia && _vm.onPlp
    ? _c(
        "a",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:swipe.left",
              value: _vm.slideNext,
              expression: "slideNext",
              arg: "swipe",
              modifiers: { left: true }
            },
            {
              name: "touch",
              rawName: "v-touch:swipe.right",
              value: _vm.slidePrevious,
              expression: "slidePrevious",
              arg: "swipe",
              modifiers: { right: true }
            }
          ],
          class: _vm.imageWrapperClasses,
          attrs: { href: _vm.product.context_url },
          on: { focus: _vm.onGalleryFocus }
        },
        [
          _vm.productHasMultipleMedia
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.imageHovered || _vm.isMobile,
                        expression: "imageHovered || isMobile"
                      }
                    ],
                    staticClass: "product-item__images-navigation"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "carousel__navigation carousel__previous-button",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.arrowPreviousLabel,
                          tabindex: "0"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.slidePrevious.apply(null, arguments)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.slidePrevious.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "data-vue-root": "Icon",
                            name: "chevron-right-thin",
                            size: "12px",
                            fill: "transparent",
                            stroke: "#C13B2A"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "carousel__navigation carousel__next-button",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.arrowNextLabel,
                          tabindex: "0"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.slideNext.apply(null, arguments)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.slideNext.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "data-vue-root": "Icon",
                            name: "chevron-right-thin",
                            size: "12px",
                            fill: "transparent",
                            stroke: "#C13B2A"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.productHasMultipleMedia
            ? _c(
                "div",
                { staticClass: "product-item__images", style: _vm.getHeight },
                [
                  _vm.productHasMultipleMedia
                    ? _c(
                        "transition-group",
                        { attrs: { name: _vm.transitionName } },
                        _vm._l(_vm.mediaImages, function(media, index) {
                          return _c("VImage", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.activeImage === index,
                                expression: "activeImage === index"
                              }
                            ],
                            key: index,
                            attrs: {
                              "alt-text": media.alt,
                              "aspect-ratio": media.aspect_ratio,
                              "disable-aspect-ratio": _vm.includesAspectRatio,
                              "enable-lazyload": false,
                              height: media.height,
                              "placeholder-src": media.placeholder_src,
                              src: media.src,
                              width: media.width
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "product-item__image" },
                [
                  _c("VImage", {
                    attrs: {
                      "alt-text": _vm.featuredImage.alt,
                      "aspect-ratio": _vm.featuredImage.aspect_ratio,
                      "disable-aspect-ratio": _vm.includesAspectRatio,
                      height: _vm.featuredImage.height,
                      "placeholder-src": _vm.featuredImage.placeholder_src,
                      src: _vm.featuredImage.src,
                      width: _vm.featuredImage.width
                    }
                  })
                ],
                1
              )
        ],
        1
      )
    : _c(
        "a",
        {
          class: _vm.imageWrapperClasses,
          attrs: {
            href: _vm.product.context_url,
            "aria-label": _vm.product.title
          }
        },
        [
          _vm._t("quickShopBtn"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "product-item__image" },
            [_vm._t("placeholderMedia")],
            2
          )
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }